import { useNavigate } from 'react-router-dom';

import { Question, Survey } from '../../../../types/domainModels';

import { HeaderWithEdit } from '../HeaderWithEdit/HeaderWithEdit';

export const Overview = ({
  questions,
  survey,
}: {
  questions: Question[];
  survey: Survey;
}): JSX.Element => {
  const navigate = useNavigate();
  const nonDemographicQuestionCount = questions.filter(
    (q) => !q.isDemographic && q.isActive,
  ).length;

  return (
    <div className="space-y-4">
      <HeaderWithEdit
        onClickEdit={() => {
          navigate(`/surveys/${survey.id}/build/overview`);
        }}
        title="Overview"
      />
      <div className="grid grid-cols-[300px_400px]">
        <div>Title:</div>
        <div>{survey.title}</div>
      </div>
      {survey.wave.waveValue > 1 && (
        <div className="grid grid-cols-[300px_400px]">
          <div>Wave:</div>
          <div>{survey.wave.title}</div>
        </div>
      )}
      <div className="grid grid-cols-[300px_400px]">
        <div># of respondents:</div>
        <div>{survey.participants}</div>
      </div>
      <div className="grid grid-cols-[300px_400px]">
        <div>Estimated incidence:</div>
        <div>{survey.incidenceType.name}</div>
      </div>
      <div className="grid grid-cols-[300px_400px]">
        <div># of questions:</div>
        <div>{nonDemographicQuestionCount}</div>
      </div>
    </div>
  );
};
